import type { FaireProductEntity } from "../../entity_types/product";

export const p_aaez2vb2dq: FaireProductEntity = {
  token: "p_aaez2vb2dq",
  type: "product",
  name: "Nanette Tote",
  brandToken: "b_7yc0xhlyll",
  brandName: "Urban Expressions",
  imageUrl:
    "https://cdn.faire.com/fastly/f3474e0c38d4cc8bb2f9f7c5c792aff686b61ed5fc69e81a848a61046b6d53d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1dbf2e7646a439bb8de58ccae6e8d654c6050c28ff7292a25eb61ff9989e5d04.jpeg",
    "https://cdn.faire.com/fastly/032a4c67841453439636f10a749c9d19010aa3a2688782ce2ecbfccc1149f1dc.jpeg",
    "https://cdn.faire.com/fastly/9dbe0a6ca1129872a9dc3b9fffe6e49106e39ed4ab8766de2486257280c7677d.jpeg",
    "https://cdn.faire.com/fastly/3df32cc0eee6422dc50ff19bf78ef2b7f869dabb77d0fa2c2b41a667303ae41f.jpeg",
    "https://cdn.faire.com/fastly/374413bed17074a0b63098ff6d221112f0f0615cb23db41c93a6224488efb26e.jpeg",
    "https://cdn.faire.com/fastly/f7d0d5b2fcb1547af39079b292992d2e8139a4bf7f25d36cf40165bd0f0148df.jpeg",
    "https://cdn.faire.com/fastly/e1b75b279aba101eba63e9640f3a2fe15d5f74a68bf1d55edd064722e5b14bb7.jpeg",
    "https://cdn.faire.com/fastly/9e4718df384f4b281ea1d35f65328fe07c33b3d9f8531a9fcfedbdbe99738733.jpeg",
    "https://cdn.faire.com/fastly/b7a7b29deb4f08511d31301faa40352d0fdc3f6153e59e386f30dd00a8169673.jpeg",
  ],
  priceDollars: 48.5,
  description:
    "Nanette Tote: V-cut woven shopper with sleek trim.\n\nRoomy interior, long shoulder straps, removable drawstring pouch for secure storage.\n\nLightweight, breathable construction for errands, beach days or commutes. Vegan-leather trim adds structure and modern contrast.\n\nDurable, versatile and on-trend, it pairs effortlessly with casual or polished looks. An ethical, everyday tote for style-conscious women who want function without luxury price.\n\r*Item Type: Tote\n*Material: Vegan Leather\n*Closure: Drawstring pouch secures items within the main compartment, allowing quick cinch closure while the open tote provides easy access when needed.\n*Exterior Details: Woven open mesh body with reinforced faux-leather trim and long shoulder straps, plus a structured base that helps the tote stand upright when loaded.\n*Interior Details: Removable fabric pouch cinches closed to conceal contents, with an interior slip pocket and a metal clip for keys or small accessories for organization.",
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:04.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
